
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 14.25a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zM12 14.25a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zM17.25 12a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0z"}})])
          )
        }
      }
    